import { composeReducer } from 'redux-compose-reducer';

const initialState = {
  accessToken: localStorage.getItem('accessToken') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  suAccessToken: localStorage.getItem('suAccessToken') || '',
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  admin: localStorage.getItem('admin') ? JSON.parse(localStorage.getItem('admin')) : null
};

function logIn(state, action) {
  return {
    ...state,
    accessToken: action.accessToken,
    suAccessToken: action.suAccessToken,
    refreshToken: action.refreshToken,
    user: action.user,
    admin: action.admin
  };
}

function logOut(state) {
  return { ...state, accessToken: '', suAccessToken: '', refreshToken: null, user: null, admin: null };
}

export default composeReducer('auth', {
  logIn,
  logOut
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/auth.js